import ThirdStepForm from './ThirdStepForm';

export * from './types';

export default ThirdStepForm;
